import {
    Object3D,
    SphereBufferGeometry,
    MeshLambertMaterial,
    Mesh,
    LineBasicMaterial,
    Geometry,
    Vector3,
    Line,
    Sprite,
    SpriteMaterial,
    PlaneBufferGeometry,
    Color,
    DoubleSide, PointLight,
    AxesHelper
} from "three";
import bidello,{component} from "bidello";
import camera from "../camera";
import {CSS2DObject} from "three/examples/jsm/renderers/CSS2DRenderer";
import * as THREE from 'three';
import TWEEN from 'three/examples/jsm/libs/tween.module.min';
import {degToRad, distance} from "math-toolbox";

export class CelestialBody extends component(Object3D){

    init(){



        this.interactiveSpriteMaterial = new SpriteMaterial({color:0xffffff,transparent:true,opacity:0});
        this.interactiveSprite = new Sprite(this.interactiveSpriteMaterial);
        this.viewGroup = new Object3D();
        this.planetGroup = new Object3D();
        this.planetInfo = new Object3D();
        this.revolutionDays = 30;
        this.orbitalDays = 1
        this.label = "Planet";
        this.rotationAllowed = true;
        this.orbitLineMaterial = new LineBasicMaterial( {
            color: 0xffffff,
            linewidth: 1,
            linecap: 'round', //ignored by WebGLRenderer
            linejoin:  'round' //ignored by WebGLRenderer
        } );


        this.sunSize = camera.calculateUnitSize().height*0.35;
        this.interactiveSprite.scale.multiplyScalar(camera.calculateUnitSize().height);
        this.planetScale = 1;

        this.bodyMesh = null;

        this.planetInfo.add(this.planetGroup)
        //this.planetGroup.add(this.interactiveSprite)
        this.createLabel();
        this.viewGroup.add(this.planetInfo);
        this.viewGroup.rotateX(Math.PI/2)

        this.add(this.viewGroup);




        this.light = new PointLight(0xffffff,20,50);

        this.viewGroup.add(this.light);

        this.name = "planet";
    }

    setLabel (label){

        this.label = label;
        this.labelCSS3D.element.textContent = this.label;
    }

    setLabelVisibility (visible = true){

        if (!visible)this.labelCSS3D.element.textContent = "";
        if (visible)this.labelCSS3D.element.textContent = this.label;

    }

    createLabel (){

        const labelElement = document.createElement('div');
        labelElement.classList.add("planet-label");
        labelElement.classList.add("text-uppercase");
        //labelElement.classList.add("text--emphasis");
        labelElement.classList.add("font-color--white");
        labelElement.classList.add("font-size--paragraph");
        labelElement.textContent = "planet";
        this.labelCSS3D = new CSS2DObject(labelElement);
        this.labelCSS3D.scale.multiplyScalar(0.01)
        this.labelCSS3D.position.setZ(camera.calculateUnitSize().height*0.5)
        this.planetGroup.add(this.labelCSS3D)

    }

    attachMesh (mesh) {

        this.bodyMesh = mesh;
        this.bodyMesh.rotation.y = Math.PI/2*-1
        //this.bodyMesh.rotation.x = Math.PI
        mesh.scale.multiplyScalar(0.5)
        this.planetGroup.add(this.bodyMesh);

    }

    setAxisAngle (rotation=1){

        this.planetGroup.rotateX(degToRad(rotation))

    }

    setSunDistance (sizeInKm){

        const distanceInSunSize = sizeInKm/CelestialBody.REAL_SUN_SIZE;
        this.planetGroup.position.setX(this.sunSize*distanceInSunSize);
        this.light.position.setX(this.planetGroup.position.x+10)
        this.light.position.setY(this.planetGroup.position.y+10)
        this.light.position.setZ(this.planetGroup.position.z-5)


    }

    setDistanceFromOrbit(distance){


        this.planetGroup.position.setY(distance);

    }

    orbitAround (object3D,distance){



    }

    setDaysTillBigBang (days){

        this.viewGroup.rotation.z+=(0.001/this.orbitalDays)*days;

    }

    setRealSize (sizeInKm, compensate = 1){

        let planetScale = sizeInKm/CelestialBody.REAL_SUN_SIZE;
        this.planetScale = planetScale*compensate;
        if (this.planetScale<0.1)this.planetScale = 0.1
        this.bodyMesh.scale.multiplyScalar(this.planetScale );
        this.labelCSS3D.position.multiplyScalar(this.planetScale );
        this.interactiveSprite.scale.multiplyScalar(this.planetScale);


    }





    onRaf(delta){

        //this.planetGroup.rotation.z+=(0.01/this.revolutionDays);
        //if (this.rotationAllowed)this.viewGroup.rotation.z+=(0.001/this.orbitalDays);

    }

    hideOrbit (){


    }
    showOrbit (){


    }



}

CelestialBody.REAL_SUN_SIZE = 1392000;
CelestialBody.MIN_PLANET_SCALE = 0.5;

